"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormHeroCheckbox", {
    enumerable: true,
    get: function() {
        return FormHeroCheckbox;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _Text = require("../../Text/Text");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormHeroCheckbox = /*#__PURE__*/ _react.default.forwardRef((props, ref)=>{
    const { label, description, value: propsValue, icon: Icon, onChange, className, ...inputProps } = props;
    const { colors } = (0, _Theme.useTheme)();
    const { id, hintId, hasError } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const [localValue, setLocalValue] = (0, _react.useState)(propsValue !== null && propsValue !== void 0 ? propsValue : false);
    const value = (0, _react.useMemo)(()=>propsValue !== null && propsValue !== void 0 ? propsValue : localValue, [
        propsValue,
        localValue
    ]);
    const inputId = (0, _react.useMemo)(()=>{
        var _props_id, _ref;
        return (_ref = (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id) !== null && _ref !== void 0 ? _ref : props.name;
    }, [
        id,
        props.id,
        props.name
    ]);
    const handleChange = (e)=>{
        setLocalValue(e.target.checked);
        if (onChange != null) {
            onChange(e);
        }
    };
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("label", {
        htmlFor: inputId,
        className: _style.default.dynamic([
            [
                "6a866f75027098d1",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + ("label ".concat(value ? "label--active" : "", " ").concat(hasError ? "label--error" : "", " ").concat(className !== null && className !== void 0 ? className : "").trim() || "")
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6a866f75027098d1",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + "control"
    }, /*#__PURE__*/ _react.default.createElement(Icon, {
        size: 24,
        fill: value ? colors.blue[60] : "#000",
        className: _style.default.dynamic([
            [
                "6a866f75027098d1",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ])
    }), /*#__PURE__*/ _react.default.createElement("input", {
        ...inputProps,
        ref: ref,
        id: inputId,
        "aria-describedby": hintId,
        type: "checkbox",
        checked: value,
        onChange: handleChange,
        className: _style.default.dynamic([
            [
                "6a866f75027098d1",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + (inputProps && inputProps.className != null && inputProps.className || "")
    })), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "6a866f75027098d1",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + "info"
    }, /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "heading",
        size: "small",
        className: "mb-2"
    }, label), /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "text",
        size: "extra-small",
        className: "description m-0"
    }, description))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "6a866f75027098d1",
        dynamic: [
            colors.grayscale[20],
            colors.blue[60],
            colors.transparent.black[10],
            colors.transparent.black[5],
            colors.status.danger.primary,
            colors.blue[10],
            colors.blue[60],
            colors.transparent.black[60]
        ]
    }, 'input[type="checkbox"].__jsx-style-dynamic-selector{width:24px;height:24px;background:#fff;border:1px solid '.concat(colors.grayscale[20], ';-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;position:relative;margin:0}input[type="checkbox"].__jsx-style-dynamic-selector:checked{border:none}input[type="checkbox"].__jsx-style-dynamic-selector:checked:before{content:"";background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHSURBVHgB7ZPRDYAgDEQ7giM4ghs6GiM4AiMwwlmiH4YgqIEzIX1JwxfcC21FDMMwOgNg1nLxFDZnuMeBp0ok4ZFNaxIGY4R/6VfL8EUraK0v7rT79uShqgRa9/zyA1UJ9Bq4JxLoPe0lCbBWLScB9p5nJAItvCDBC7+R4IYnEu6XcMMwhmQHt/C0plArFXgAAAAASUVORK5CYII=");-webkit-background-size:16px 16px;-moz-background-size:16px 16px;-o-background-size:16px 16px;background-size:16px 16px;background-repeat:no-repeat;background-position:center;position:absolute;top:0;left:0;right:0;bottom:0;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;background-color:').concat(colors.blue[60], ";color:#fff}.label.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;white-space:nowrap;max-width:100%;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding:1rem;border:1px solid ").concat(colors.transparent.black[10], "}.label.__jsx-style-dynamic-selector:not(.label--active):hover{background-color:").concat(colors.transparent.black[5], "}.label--error.__jsx-style-dynamic-selector,.label-error.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{border-color:").concat(colors.status.danger.primary, "}.label--active.__jsx-style-dynamic-selector{background-color:").concat(colors.blue[10], ";border-color:").concat(colors.blue[60], "}.control.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:.5rem}.info.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.info.__jsx-style-dynamic-selector .description{color:").concat(colors.transparent.black[60], "}")));
});
FormHeroCheckbox.displayName = "FormHeroCheckbox";

//# sourceMappingURL=FormHeroCheckbox.js.map